const englishTabs = {
    dashboard: "Dashboard",
    dailyEntry: "DailyEntry",
    accounts: "Accounts",
    cashControl: "Cash Control",
    hrPayroll: "HrPayroll",
    purchases: "Purchases",
    sales: "Sales",
    expenses: "Expenses",
    stock: "Stock",
    inventory: "Inventory",
    reports: "Reports",
    tools: "Tools",
    settings: "Settings",
    retail: "Retail",
};


const arabicTabs = {
    dashboard: "لوحة التحكم",
    dailyEntry: "القيود اليومية",
    accounts: "الحسابات",
    cashControl: "إدارة النقد",
    hrPayroll: "الموارد البشرية",
    purchases: "المشتريات",
    sales: "المبيعات",
    expenses: "المصروفات",
    stock: "المخزون",
    inventory: "الجرد",
    reports: "التقارير",
    tools: "الأدوات",
    settings: "الإعدادات",
    retail: "التجزئة",
};



const englishPages = {
    salesDashboard: "salesDashboard",
    chartOfAccount: "ChartOfAccount",
    myAccounts: "MyAccounts",
    groups: "Groups",
    delivery: "Delivery",

    cashAccount: "Cash Account",
    varianceAccount: "Variance Account",
    cashTransfer: "Cash Transfer",
    payments: "Payments",
    receipts: "Receipts",

    employee: "Employee",
    salary: "Salary",

    supplier: "Supplier",
    purchaseInvoice: "Purchase Invoice",
    purchaseReturn: "Purchase Return",
    purchaseOrder: "Purchase Order",

    customer: "Customer",
    salesInvoice: "Sales Invoice",
    salesReturn: "Sales Return",
    salesOrder: "Sales Order",

    expenseAccount: "Expense Account",
    expenseSupplier: "Expense Supplier",
    expenseInvoice: "Expense Invoice",

    stockControl: "Stock Control",
    stockTransfer: "Stock Transfer",

    products: "Products",
    categories: "Categories",
    brands: "Brands",
    seasons: "Seasons",
    vatGroup: "VatGroup",

    financial: "Financial",
    operational: "Operational",
    stockReport: "Stock Report",
    sessions: "Sessions",

    //tools
    stockTools: "Stock Tools",
    openingYear: "Opening Year",
    posTools: "PosTools",
    import: "Import",
    backup: "Backup",

    //settings
    general: "General",
    user: "User",
    role: "Role",
    linkAccount: "Link Account",
    currency: "Currency",

      //retail
      pos: "POS",

};


const arabicPages = {
    salesDashboard: "جدول المبيعات",
    chartOfAccount: "دليل الحسابات",

    myAccounts: "حساباتي",
    groups: "المجموعات",
    delivery: "التوصيل",
    
    cashAccount: "حساب النقدية",
    varianceAccount: "حساب الفروقات",
    cashTransfer: "تحويل نقدي",
    payments: "المدفوعات",
    receipts: "الإيصال",

    employee: "الموظف",
    salary: "الراتب",

    supplier: "المورد",
    purchaseInvoice: "فاتورة الشراء",
    purchaseReturn: "إرجاع الشراء",
    purchaseOrder: "طلب الشراء",

    customer: "العميل",
    salesInvoice: "فاتورة المبيعات",
    salesReturn: "إرجاع المبيعات",
    salesOrder: "طلب المبيعات",

    expenseAccount: "حساب المصروفات",
    expenseSupplier: "مورد المصروفات",
    expenseInvoice: "فاتورة المصروفات",

    stockControl: "مراقبة المخزون",
    stockTransfer: "تحويل المخزون",

    products: "المنتجات",
    categories: "الفئات",
    brands: "العلامات التجارية",
    seasons: "المواسم",
    vatGroup: "مجموعة الضريبة",

    financial: "المالية",
    operational: "التشغيلية",
    stockReport: "تقرير المخزون",
    sessions: "الجلسات",

    //tools
    stockTools: "أدوات المخزون",
    openingYear: "السنة الافتتاحية",
    posTools: "أدوات نقطة البيع",
    import: "استيراد",
    backup: "النسخ الاحتياطي",

    //settings
    general: "الإعدادات العامة",
    user: "المستخدم",
    role: "الدور",
    linkAccount: "ربط الحساب",
    currency: "العملة",

    //retail
    pos: "نقطة البيع",
};


export {
    englishTabs,
    arabicTabs,

    englishPages,
    arabicPages,
};